<div class="row">
  <div class="col-12">
    <div class="tab-bar">
      <button class="tab-btn"
              [class.active]="activeView === 'realized'"
              (click)="setView('realized')">
        Realized P&amp;L
      </button>

      <button class="tab-btn"
              [class.active]="activeView === 'summary'"
              (click)="setView('summary')">
        Summary
      </button>
    </div>
  </div>
</div>
<div class="row">
  <div class="col-12">
    <!-- Content area -->
      <app-trading-dashboard-realized-pnl *ngIf="activeView === 'realized'">
      </app-trading-dashboard-realized-pnl>

      <app-trading-dashboard-summary *ngIf="activeView === 'summary'">
      </app-trading-dashboard-summary>
    
  </div>
</div>
